import FeatureBox from '@/components/subComponents/FeatureBox'
import React from 'react'
import { assets } from '@/helpers/common'

export const titleWithDetails = {
  features: [
    {
      title: '6 Months Free Storage',
      icon: assets('images/book-now/benefit_01.png'),
      content:
        'Why keep your own luggage, bike, ski, golf clubs, or moving boxes at home? We can keep it for you and ship it to your destination whenever you want.'
    },
    {
      title: 'Cost Effective Shipping Service',
      icon: assets('images/book-now/benefit_02.png'),
      content: 'We can save up to 70% in shipping fees for any of your items.'
    },
    {
      title: 'Minimum Charge/Month',
      icon: assets('images/book-now/benefit_03.png'),
      content:
        'We offer 6 months of free storage for your items. Extended time storage is available at $10 per month for each piece of luggage, bag or box.'
    },
    {
      title: 'World Class Logistics Partners',
      icon: assets('images/book-now/benefit_04.png'),
      content: 'We have partnership with FedEx and DHL and we can give you flexible shipping options.'
    },
    {
      title: 'Worldwide Drop-off Locations',
      icon: assets('images/book-now/benefit_05.png'),
      content:
        'As we have partnership with the most trustable couriers in the world, you will get the benefit of more than 25000 worldwide drop off locations.'
    },
    {
      title: '24/7 Customer Service',
      icon: assets('images/book-now/benefit_06.png'),
      content: 'We have dedicated customer service experts to hear from you anytime in both Arabic and English '
    }
  ],
  features_two: [
    {
      title: 'Location of Storage Facility',
      icon: assets('images/book-now/feature-01.png'),
      content:
        'We offer multiple storage location for your convenience and cost saving. Shipping fee from your location to Storage facility depends on distance',
      readMoreTo: '/',
      readMoreText: 'Learn More'
    },
    {
      title: 'Your Packaging Type and Sizes',
      icon: assets('images/book-now/feature-02.png'),
      content:
        'We have certain limits for weight of Box/Luggage/Golf Bag and Packages. This limits for Shipping Security and shipping cost directly. Please make sure your packaging in our limits and condition.',
      readMoreTo: '/',
      readMoreText: 'Learn More'
    },
    {
      title: '6 Months Free Storage',
      icon: assets('images/book-now/feature-03.png'),
      content:
        'We offer 6 month off free storage for your packages. Over 6 months just pay $10 a months for each packages. It is Simple Smart and cost saving solution',
      readMoreTo: '/',
      readMoreText: 'Learn More'
    }
  ],
  safe_service: [
    {
      title: 'Biometric System Acces',
      icon: assets('images/book-now/safe_service_icon_01.png'),
      content: false
    },
    {
      title: 'Insurance Coverage',
      icon: assets('images/book-now/safe_service_icon_05.png'),
      content: false
    },
    {
      title: 'Barcode Tracking System',
      icon: assets('images/book-now/safe_service_icon_02.png'),
      content: false
    },
    {
      title: 'Fire Control',
      icon: assets('images/book-now/safe_service_icon_06.png'),
      content: false
    },
    { title: 'Pest Control', icon: assets('images/book-now/safe_service_icon_03.png'), content: false },
    {
      title: 'CCTV Monitoring',
      icon: assets('images/book-now/safe_service_icon_07.png'),
      content: false
    },
    {
      title: 'Pickup from Door Step',
      icon: assets('images/book-now/safe_service_icon_04.png'),
      content: false
    },
    {
      title: '24/7 Security',
      icon: assets('images/book-now/safe_service_icon_08.png'),
      content: false
    }
  ]
}

export const getBookNowBanner = () => {
  let bannerAfter = false,
    mobileBanner = false,
    tabBanner = false,
    desktopBanner = false

  return {
    desktopBanner,
    tabBanner,
    mobileBanner,
    bannerAfter
  }
}

export const book_now_benefits = titleWithDetails.features.map((item, key) => {
  return (
    <div key={item.title + key} className='px-5 lg-mx:px-0 text-center'>
      <FeatureBox className='style-two' title={item.title} icon={item.icon} content={item.content} />
    </div>
  )
})
export const book_now_what_you_should_know = titleWithDetails.features_two.map((item, key) => {
  return (
    <div key={item.title + key} className='px-5 lg-mx:px-0 text-center'>
      <FeatureBox
        className='style-two'
        title={item.title}
        icon={item.icon}
        content={item.content}
        readMore={true}
        readMoreTo={item.readMoreTo}
        readMoreText={item.readMoreText}
        readMoreClass='text-sm font-semibold text-secondary underline'
      />
    </div>
  )
})

const Contents = {
  titleWithDetails,
  getBookNowBanner,
  book_now_benefits,
  book_now_what_you_should_know
}

export default Contents
